export default __webpack_public_path__ + "static/media/About-Us.9beb922d.jpg";